<template>
  <div class="page">
    <div class="m-b-24 bg-content padding15">
      <el-form size="small" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="公司">
              <el-select v-model="company.companySelected" filterable placeholder="请选择" style="width: 100%;" @change="companyChange" clearable>
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="策略组">
              <el-select v-model="group.groupSelected" placeholder="请选择" style="width: 100%;" @change="groupChange" filterable clearable>
                <el-option
                  v-for="item in group.groupOption"
                  :key="item.groupId"
                  :label="item.groupName"
                  :value="item.groupId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" style="margin-top: 12px;">
          <el-col :span="10">
            <el-form-item label="状态">
              <el-select v-model="statusSelected" placeholder="请选择" style="width: 100%;" clearable>
                <el-option label="待启用" value="0"></el-option>
                <el-option label="生效中" value="1"></el-option>
                <el-option label="已失效" value="2"></el-option>
                <el-option label="临时数据清洗" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="text right" style="margin-top: 24px;">
              <el-button type="primary" size="small" @click="search">查询</el-button>
              <el-button size="small" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content padding15">
      <div class="table-header">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column prop="companyName" label="公司" min-width="180"></el-table-column>
        <el-table-column label="策略组" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.groupName }}</span>
            <span style="color: #999; font-size: 12px;">({{ scope.row.groupId }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="msgUnitPrice" label="短信单价（元）" min-width="120"></el-table-column>
        <el-table-column label="语音计费模式" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.svoiceChargeMode === 1">按分钟</span>
            <span v-else-if="scope.row.svoiceChargeMode === 2">按接通次数</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="svoiceUnitPrice" label="语音单价（元）" min-width="120"></el-table-column>
        <el-table-column label="状态" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: #909399;">待启用</span>
            <span v-else-if="scope.row.status === 1" style="color: #67C23A;">生效中</span>
            <span v-else-if="scope.row.status === 2" style="color: #F56C6C;">已失效</span>
            <span v-else-if="scope.row.status === 3" style="color: #E6A23C;">临时数据清洗</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="生效时间" min-width="100"></el-table-column>
        <el-table-column prop="endTime" label="失效时间" min-width="100"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="150"></el-table-column>
        <el-table-column prop="updateUser" label="更新人" min-width="100"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)"><i class="el-icon-edit-outline"></i> 编辑</el-button>
            <el-button type="text" size="small" @click="handleCopy(scope.row)"><i class="el-icon-document-copy"></i> 复制</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-position">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="dialogClose" class="settlement-dialog">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司" style="width: 100%;" @change="dialogCompanyChange" :disabled="dialogType === 'edit'" filterable>
            <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="策略组" prop="groupIds">
          <div class="group-select-wrapper">
            <el-select v-model="form.groupIds" placeholder="请选择策略组" style="width: 100%;" :disabled="dialogType === 'edit'" filterable multiple collapse-tags>
              <el-option v-for="item in dialogGroupOption" :key="item.groupId" :label="item.groupName" :value="item.groupId"></el-option>
            </el-select>
            <div v-if="dialogType !== 'edit'" class="group-select-actions">
              <a href="javascript: void(0);" @click="selectAllGroups">全选</a>
              <span class="divider">|</span>
              <a href="javascript: void(0);" @click="clearAllGroups">清除</a>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="短信单价（元）" prop="msgUnitPrice">
          <div class="price-input-wrapper">
            <el-button size="small" icon="el-icon-minus" @click="adjustPrice('msgUnitPrice', -0.001)"></el-button>
            <el-input-number v-model="form.msgUnitPrice" :precision="3" :step="0.001" :min="0" placeholder="请输入短信单价" controls-position="right"></el-input-number>
            <el-button size="small" icon="el-icon-plus" @click="adjustPrice('msgUnitPrice', 0.001)"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="语音计费模式" prop="svoiceChargeMode">
          <el-select v-model="form.svoiceChargeMode" placeholder="请选择语音计费模式" style="width: 100%;">
            <el-option label="按分钟" :value="1"></el-option>
            <el-option label="按接通次数" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语音单价（元）" prop="svoiceUnitPrice">
          <div class="price-input-wrapper">
            <el-button size="small" icon="el-icon-minus" @click="adjustPrice('svoiceUnitPrice', -0.001)"></el-button>
            <el-input-number v-model="form.svoiceUnitPrice" :precision="3" :step="0.001" :min="0" placeholder="请输入语音单价" controls-position="right"></el-input-number>
            <el-button size="small" icon="el-icon-plus" @click="adjustPrice('svoiceUnitPrice', 0.001)"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="生效时间" prop="startTime">
          <div class="date-input-wrapper">
            <el-date-picker v-model="form.startTime" type="date" placeholder="选择生效时间" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            <el-button size="small" @click="setToday">今天</el-button>
          </div>
        </el-form-item>
        <el-form-item label="失效时间" prop="endTime">
          <el-date-picker v-model="form.endTime" type="date" placeholder="为空则长期有效" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitLoading">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: {
        companySelected: '',
        companyOption: []
      },
      group: {
        groupSelected: '',
        groupOption: []
      },
      statusSelected: null,
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      groupReq: {
        companyId: ''
      },
      dialogVisible: false,
      dialogType: 'add',
      dialogTitle: '新增结算单价',
      submitLoading: false,
      dialogGroupOption: [],
      form: {
        id: '',
        companyId: '',
        groupId: '',
        groupIds: [],
        msgUnitPrice: '',
        svoiceChargeMode: 1,
        svoiceUnitPrice: '',
        startTime: '',
        endTime: '',
        remark: ''
      },
      rules: {
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        groupIds: [{ required: true, message: '请选择策略组', trigger: 'change' }],
        msgUnitPrice: [{ required: true, message: '请输入短信单价', trigger: 'blur' }],
        svoiceChargeMode: [{ required: true, message: '请选择语音计费模式', trigger: 'change' }],
        svoiceUnitPrice: [{ required: true, message: '请输入语音单价', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择生效时间', trigger: 'change' }]
      }
    };
  },
  mounted() {
    this.getCompanyOptionList();
    this.getList();
  },
  methods: {
    adjustPrice(field, delta) {
      if (!this.form[field]) {
        this.form[field] = 0;
      }
      this.form[field] = parseFloat((this.form[field] + delta).toFixed(3));
      if (this.form[field] < 0) {
        this.form[field] = 0;
      }
    },
    setToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.form.startTime = `${year}-${month}-${day}`;
    },
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.company.companyOption = res.data;
      });
    },
    companyChange() {
      this.group.groupSelected = '';
      if (this.company.companySelected) {
        this.groupReq.companyId = this.company.companySelected;
        this.getGroupOptionList(this.groupReq);
      } else {
        this.group.groupOption = [];
      }
    },
    groupChange() {
      this.getList();
    },
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/getGroupData',
        method: 'POST',
        data: { companyId: dataReq.companyId }
      }).then((res) => {
        this.group.groupOption = res.data;
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    reset() {
      this.company.companySelected = '';
      this.group.groupSelected = '';
      this.statusSelected = null;
      this.tableData = [];
      this.pagination.total = 0;
      this.pagination.page = 1;
    },
    getList() {
      this.tableLoading = true;
      const params = {
        model: {
          companyId: this.company.companySelected,
          groupId: this.group.groupSelected,
          status: this.statusSelected
        },
        pageQueryParam: {
          page: this.pagination.page,
          limit: this.pagination.limit
        }
      };
      this.$ajax({
        url: '/groupUnitPriceDetail/getPage',
        method: 'POST',
        data: params
      }).then((res) => {
        this.tableData = res.data.list;
        this.pagination.total = res.data.totalRecords;
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },
    handleAdd() {
      this.dialogType = 'add';
      this.dialogTitle = '新增结算单价';
      this.dialogVisible = true;
      this.resetForm();
    },
    handleEdit(row) {
      this.dialogType = 'edit';
      this.dialogTitle = '编辑结算单价';
      this.form = {
        id: row.id,
        companyId: row.companyId,
        groupId: row.groupId,
        groupIds: [row.groupId],
        msgUnitPrice: row.msgUnitPrice,
        svoiceChargeMode: row.svoiceChargeMode,
        svoiceUnitPrice: row.svoiceUnitPrice,
        startTime: row.startTime,
        endTime: row.endTime,
        remark: row.remark,
        version: row.version
      };
      this.dialogGroupReq = { companyId: row.companyId };
      this.getDialogGroupOption(row.companyId);
      this.dialogVisible = true;
    },
    handleCopy(row) {
      this.dialogType = 'copy';
      this.dialogTitle = '新增结算单价';
      this.form = {
        id: '',
        companyId: row.companyId,
        groupId: row.groupId,
        groupIds: [row.groupId],
        msgUnitPrice: row.msgUnitPrice,
        svoiceChargeMode: row.svoiceChargeMode,
        svoiceUnitPrice: row.svoiceUnitPrice,
        startTime: row.startTime,
        endTime: row.endTime,
        remark: row.remark
      };
      this.dialogGroupReq = { companyId: row.companyId };
      this.getDialogGroupOption(row.companyId);
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除该结算单价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/groupUnitPriceDetail/delete',
          method: 'POST',
          data: { id: row.id }
        }).then(() => {
          this.$message.success('删除成功');
          this.getList();
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    dialogCompanyChange() {
      this.form.groupIds = [];
      this.dialogGroupReq = { companyId: this.form.companyId };
      this.getDialogGroupOption(this.form.companyId);
    },
    getDialogGroupOption(companyId) {
      this.$ajax({
        url: '/strategy/getGroupData',
        method: 'POST',
        data: { companyId }
      }).then((res) => {
        this.dialogGroupOption = res.data;
      });
    },
    selectAllGroups() {
      this.form.groupIds = this.dialogGroupOption.map(item => item.groupId);
    },
    clearAllGroups() {
      this.form.groupIds = [];
    },
    dialogClose() {
      this.resetForm();
    },
    resetForm() {
      this.form = {
        id: '',
        companyId: '',
        groupId: '',
        groupIds: [],
        msgUnitPrice: '',
        svoiceChargeMode: 1,
        svoiceUnitPrice: '',
        startTime: '',
        endTime: '',
        remark: ''
      };
      this.dialogGroupOption = [];
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$ajax({
            url: '/groupUnitPriceDetail/edit',
            method: 'POST',
            data: this.form
          }).then(() => {
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.getList();
            this.submitLoading = false;
          }).catch((err) => {
            this.submitLoading = false;
            const msg = err.msg || (err.data && err.data.msg) || '保存失败';
            this.$message.error(msg);
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  padding: 15px;
}

.m-b-24 {
  margin-bottom: 24px;
}

.bg-content {
  background: #fff;
  border-radius: 4px;
}

.padding15 {
  padding: 15px;
}

.text {
  display: flex;
  align-items: center;
}

.right {
  justify-content: flex-end;
}

.page-position {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.table-header {
  margin-bottom: 15px;
}

.dialog-footer {
  text-align: center;
  .el-button + .el-button {
    margin-left: 20px;
  }
}

.price-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  .el-input-number {
    width: 180px;
  }
}

.date-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  .el-date-editor {
    flex: 1;
  }
  .el-button {
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
    border: none;
    color: #fff;
    &:hover {
      opacity: 0.9;
    }
  }
}

.group-select-wrapper {
  position: relative;
}

.group-select-actions {
  position: absolute;
  right: 10px;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  pointer-events: auto;
  z-index: 1;
  a {
    color: #409eff;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .divider {
    color: #dcdfe6;
    margin: 0 6px;
  }
}

/deep/ .settlement-dialog {
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/settlement/index.vue